<template>
  <div class="fullPage">
    <page :title="title" :breadcrumb="breadcrumb" :load="doInit">
      <v-card>
        <form>
          <v-card-title>
            <div>
              <div class="headline">Member Group Information</div>
            </div>
            <v-spacer></v-spacer>
            <div slot="action">
              <v-tooltip top>
                <v-btn slot="activator" icon @click="doReview" v-if="checkAccess(['memberReview'])">
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
                <span>Review Member Group</span>
              </v-tooltip>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">{{labels.groupId}}</v-subheader>
                    <div class="subheading">{{memberGroupForm.groupId}}</div>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">{{labels.groupDesc}}</v-subheader>
                    <div class="subheading">{{memberGroupForm.groupDesc}}</div>
                  </v-flex>
                  <v-flex xs12>
                    <v-subheader class="queryLabel">{{labels.groupDeclaration}}</v-subheader>
                    <div v-if="memberGroupForm.groupDeclaration !== null">
                      <v-textarea v-model="memberGroupForm.groupDeclaration" readonly auto-grow></v-textarea>
                    </div>
                    <div v-else> - </div>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">{{labels.enableB2CReg}}</v-subheader>
                    <div>{{formatBoolean(memberGroupForm.enableB2CReg)}}</div>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">{{labels.restrictedGroup}}</v-subheader>
                    <div>{{formatBoolean(memberGroupForm.restrictedGroup)}}</div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-container>
          </v-card-text>
        </form>
      </v-card>
    </page>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'

export default {
  data() {
    return {
      breadcrumb: [],
      labels: {
        memberGroup: 'Member Group Information',
        groupId: 'Group Id',
        groupDesc: 'Group Description',
        groupDeclaration: 'Group Declaration',
        enableB2CReg: 'Enabled for B2C Registration',
        restrictedGroup: 'Restricted Group'
      },
      memberGroupForm: {
        groupId: undefined,
        groupDesc: undefined,
        groupDeclaration: undefined,
        enableB2CReg: false,
        restrictedGroup: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumbByName',
      'checkAccess'
    ]),
    title() {
      return 'Query Member Group'
    }
  },
  methods: {
    async doInit() {
      // Query
      await this.queryMemberGroup()
    },
    async queryMemberGroup() {
      const apiURI = this.$store.state.adminMember.menu.memberGroupGet
      if (apiURI) {
        try {
          const expand = {
            groupId: this.groupId
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Member Group init
            this.memberGroupForm.groupId = data.usrMemberGrp.groupId
            this.memberGroupForm.groupDesc = data.usrMemberGrp.groupDesc
            this.memberGroupForm.groupDeclaration = data.usrMemberGrp.groupDeclaration
            this.memberGroupForm.enableB2CReg = data.usrMemberGrp.enableB2CReg
            this.memberGroupForm.restrictedGroup = data.usrMemberGrp.restrictedGroup
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doReview() {
      this.$router.push({ name: 'memberGroupReview', params: { groupId: this.groupId } })
    }
  },
  mounted() {
    this.breadcrumb = this.derieveBreadcrumbByName('memberGroups')
    this.breadcrumb.push({
      name: 'memberGroupQuery',
      text: this.title
    })
  },
  created() {
    this.doInit()
  },
  props: {
    groupId: {
      type: String,
      default: ''
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
